import {OrderInfo} from '@/entities/OrderInfo';
import {ResHelper} from '@/helper/ResHelper';
import {apiClient} from './api-client';
import URI from 'urijs';

/**
 * Service to retrieve orders.
 */
export class OrdersService {
    private get baseUrl(): URI {
        return new URI('/api/orders');
    }

    public async getAllOrdersForUser(): Promise<OrderInfo[] | null> {
        const res = await apiClient.get<OrderInfo[]>(
            this.baseUrl.toString()
        );
        return res.data;
    }
}
